import { render, staticRenderFns } from "./CollegeImportant.vue?vue&type=template&id=24a85414&scoped=true"
import script from "./CollegeImportant.vue?vue&type=script&lang=js"
export * from "./CollegeImportant.vue?vue&type=script&lang=js"
import style0 from "./CollegeImportant.vue?vue&type=style&index=0&id=24a85414&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a85414",
  null
  
)

export default component.exports